import axios from "axios";

const LOGOUT = "LOGOUT";
const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";
const SET_PROFILE_IMAGE = "SET_PROFILE_IMAGE";

// state
export const state = {
  user: null,
  authenticated: false,
  notifications: 0,
  messages: 0,
  profileImage: null
};

// getters
export const getters = {
  user: state => state.user,
  teamId: state => state.teamId,
  profileImage: state => state.profileImage,
  team: state => state.team,
  messages: state => state.messages,
  notifications: state => state.notifications,
  authenticated: state => state.user !== null
};

// mutations
export const mutations = {
  [FETCH_USER_SUCCESS](state, { user }) {
    state.user = user;
    if(user.imageExtension == null)
    {
      state.profileImage = "/img/default-avatar.png";      
    }else{
      state.profileImage = process.env.VUE_APP_BACKEND + "/profile/image/" + state.user.id + "?=" + Date.now();
    }
  },

  [LOGOUT](state) {
    state.user = null;
  },

  [FETCH_USER_FAILURE](state) {
    state.user = null;    
  },

  [SET_PROFILE_IMAGE] (state, { profileImage }) {
    if(profileImage == null)
    {
      state.profileImage = "/img/default-avatar.png";      
    }else{
      state.profileImage = process.env.VUE_APP_BACKEND + "/profile/image/" + state.user.id + "?=" + Date.now();
    }
  }
 
};

// actions
export const actions = {

  async fetchUser({ commit }) {
    try {
      const { data } = await axios.get(
        process.env.VUE_APP_BACKEND + "/auth/isLoggedin"
      );
      commit(FETCH_USER_SUCCESS, { user: data });
    } catch (e) {
      commit(FETCH_USER_FAILURE);
    }
  },

  setProfileImage ({ commit }, { profileImage }) 
  {  
      commit(SET_PROFILE_IMAGE, { profileImage });
  },

  async NotAuthenticated({ commit }) {
    commit(LOGOUT);
  }
};
